import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

// NOTE: Add relative class to the parent component!
export function KalenderLoading() {
  const { t } = useTranslation();
  return (
    <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-3 rounded-md bg-white/75">
      <FontAwesomeIcon
        icon={faSpinnerThird}
        spin
        size="2x"
        className="text-neutrals-700"
      />
      <div className="text-sm text-neutrals-900">{t('actions.loading')}</div>
    </div>
  );
}
